// Import model
import { BomKit } from '../models/BomKit';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for BomKit - handles JSON serialization and deserialization with type validation
 */
export class BomKitSerializer {
  /**
   * Deserializes a JSON string into a BomKit instance
   */
  static deserialize(json: string): BomKit {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a BomKit instance
   */
  static fromObject(obj: any): BomKit {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to BomKit');
    }


    const instance: BomKit = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      createdBy: obj['createdBy'] as string | undefined,
      createdByName: obj['createdBy|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      parentObjectTypeName: obj['parentObjectType|Name'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      bins: obj['bins'] ? (obj['bins'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of BomKit instances
   */
  static deserializeArray(json: string): BomKit[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a BomKit instance to a JSON string
   */
  static serialize(instance: BomKit): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a BomKit instance to a plain object
   */
  static toObject(instance: BomKit): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'createdBy': instance.createdBy,
      'createdBy|Name': instance.createdByName,
      'isActive': instance.isActive,
      'parentObjectId': instance.parentObjectId,
      'parentObjectType': instance.parentObjectType,
      'parentObjectType|Name': instance.parentObjectTypeName,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'bins': instance.bins?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of BomKit instances to a JSON string
   */
  static serializeArray(instances: BomKit[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
